<template>
    <div
        class="pt-20 pb-10 px-2  sm:px-8 bg-contain"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
            backgroundColor: '#a000ff'
        }"
    >
        <h1
            class="font-primary text-center text-white text-3xl sm:text-3xl md:text-4xl lg:text-4xl leading-none mb-4 mt-6"
        >
            {{ firstChannel.title }}
        </h1>
        <h1
            class="font-primary text-center text-white text-xl sm:text-2xl md:text-3xl lg:text-3xl leading-none mb-4"
            v-html="
                slogan2 + ' ' + $config('MONTH_PRICE') + ' / ' + $config('MES')
            "
        ></h1>

        <div class="player container mx-auto mb-5">
            <FreeLivePlayer
                v-if="shouldShowPlayer && firstChannel.id != '0'"
                :channel="firstChannel"
            ></FreeLivePlayer>
            <NoPlayerBanner v-else></NoPlayerBanner>
        </div>

        <div class="buttons">
            <btn
                class="rounded-large hover:bg-yellow-dark bg-semi-transparent text-white lg:text-lg md:text-md "
                :to="{ name: 'login' }"
                >{{ $config("LOGIN") }}</btn
            >
            <btn
                class="rounded-large bg-yellow hover:bg-yellow-dark text-white lg:text-lg md:text-md"
                :to="registerOrHomeRoute"
                >{{ $config("SIGN_UP") }}</btn
            >
        </div>
        <br class="clear" />
        <div
            id="pingui-container"
            class="container mx-auto"
            v-if="shouldShowPlayer"
        >
            <div
                id="pingui-channel"
                class="container mx-auto"
                v-if="!$isMobile()"
            >
                <div
                    class="player  mb-5 w-full max-w-screen-2xl mx-auto flex flex-wrap"
                >
                    <div
                        class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10"
                        v-for="(live, ln) in firstChannel.programming"
                        v-bind:key="ln"
                    >
                        <img
                            width="312"
                            height="176"
                            class="rounded"
                            :src="live.screenshot"
                            :alt="live.title"
                        />
                        <div
                            class="progress"
                            :style="{ width: live.progress + '%' }"
                        ></div>
                        <div class="w-full text-white text-xs">
                            <span>{{ dateformat(live.start) }}</span>
                            <span class="float-right">{{
                                dateformat(live.ends)
                            }}</span>
                        </div>
                        <span
                            class="text-white font-primary"
                            v-html="live.title"
                        ></span>
                    </div>
                </div>
            </div>
            <div id="pingui-extra" class="container mx-auto" v-else>
                <div
                    class="player  mb-5 w-full max-w-screen-2xl mx-auto flex flex-wrap"
                    v-if="firstChannel"
                >
                    <div class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10">
                        <img
                            width="312"
                            height="176"
                            class="rounded"
                            :src="firstChannel.programming[0].screenshot"
                            :alt="firstChannel.programming[0].title"
                        />
                        <div
                            class="progress"
                            :style="{
                                width:
                                    firstChannel.programming[0].progress + '%'
                            }"
                        ></div>
                        <div class="w-full text-white text-xs">
                            <span>{{
                                dateformat(firstChannel.programming[0].start)
                            }}</span>
                            <span class="float-right">{{
                                dateformat(firstChannel.programming[0].ends)
                            }}</span>
                        </div>
                        <span
                            class="text-white font-primary"
                            v-html="firstChannel.programming[0].title"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Btn from "@/components/Btn";
import { mapGetters } from "vuex";
import moment from "moment";
import FreeLivePlayer from "@/components/freeLive/Player";
import NoPlayerBanner from "@/components/NoPlayerBanner.vue";

export default {
    name: "TryLiveChannel",
    components: {
        FreeLivePlayer,
        NoPlayerBanner,
        Btn
    },
    props: {
        homeData: {
            validator: prop => typeof prop === "object" || prop === null,
            required: true
        }
    },
    data() {
        return {
            shouldShowPlayer: false
        };
    },

    computed: {
        ...mapGetters(["registerOrHomeRoute", "getLiveChannels"]),

        firstChannel() {
            return this.getLiveChannels[0];
        },

        background() {
            if (!this.homeData) return "";

            return this.$isMobile()
                ? this.homeData.background_mobile
                : this.homeData.background;
        },

        slogan() {
            return this.homeData ? this.homeData.slogan : "";
        },

        slogan2() {
            return this.homeData ? this.homeData.slogan2 : "";
        }
    },
    methods: {
        dateformat: function(str) {
            return moment(str).format("HH:mm");
        }
    }
};
</script>

<style lang="scss" scoped>
.progress {
    height: 5px;
    background: red;
    width: 0%;
}
.buttons {
    display: block;
    text-align: center;
    height: 3em;
    width: 28em;
    max-width: 100%;
    margin: auto;
    .btn {
        width: 9em;
        padding: 0.5em;
        white-space: nowrap;
        text-align: center;
        display: block;
        float: left;
        margin: 0 0.5em;
    }
}
</style>
